// IdError — sum of the two parse-side failure modes every `to` shares.
//
// Discriminants are globally-unique-across-BCs per the standing rule
// (`answers-to-app.md` §1).
//
// Accessed via the qualified name: `IdError.Malformed`,
// `IdError.mkMalformed(...)`. The variants are types inside this
// module — not further submodules — mirroring `Actor`.
export { mkMalformed, mkUnexpectedShape };
const mkMalformed = (brand, input) => ({
    type: "id_malformed",
    brand,
    input,
});
const mkUnexpectedShape = (brand, input, reason) => ({
    type: "id_unexpected_shape",
    brand,
    input,
    reason,
});
//# sourceMappingURL=idError.js.map